const importWizard = {
  steps: {
    upload: "Hlaða upp",
    parse: "Forskoðun og dálkar",
    columns: "Upplýsingar og aðgangur",
    confirm: "Staðfesta",
  },
  delimiters: {
    comma: "Komma",
    semicolon: "Semíkomma",
    tab: "Tab",
    other: "Annað",
  },
  pii: {
    ariaLabel: "Líklega persónuupplýsingar: {{reasons}}",
    tooltipHeading: "Líklega persónuupplýsingar vegna:",
  },
  upload: {
    readingFile: "Les skrá…",
    clickOrDrag: "Smelltu til að velja eða dragðu skrá hingað",
    fileTypesHint: "CSV, TSV, TXT, XLSX eða SAS7BDAT · að hámarki 50 MB",
  },
  parse: {
    delimiterLabel: "Afmörkunartákn",
    optionsLabel: "Valkostir",
    customDelimiterAriaLabel: "Sérsniðið afmörkunartákn",
    customDelimiterTitle: "Sláðu inn einn staf sem aðgreinir dálka",
    headerRowLabel: "Fyrsta röð inniheldur dálkaheiti",
    sheetsListLabel: "Blöð í þessari vinnubók",
    sheetMeta: "{{rows}} raðir · {{columns}} dálkar",
    storeAsLabel: "Vista þessa innsendingu sem",
    storeAsWorkbookOption:
      "Excel-vinnubók — öll blöð, snið og formúlur varðveitt; niðurhal skilar raunverulegri .xlsx-skrá.",
    storeAsCsvOption:
      "Fletja út í staðlað CSV til að virkja fleiri fyrirspurnarmöguleika.",
    sasHint: "SAS-gagnasafn — dálkar greindir sjálfkrafa út frá lýsigögnum skrárinnar.",
  },
  preview: {
    label: "Forskoðun",
    caption:
      "{{columnCount}} dálkar greindir · sýnir fyrstu {{shown}} af {{total}} röðum",
  },
  columns: {
    datasetNameLabel: "Heiti gagnasafns",
    datasetNamePlaceholder: "t.d. Hjartadeildargögn 2026",
    piiPreselectedBanner_one:
      "{{count}} dálkur var forvalinn með sjálfvirkri greiningu á persónuupplýsingum. Haltu músinni yfir ? til að sjá hvers vegna, og taktu hakið úr ef hann inniheldur ekki í raun persónuupplýsingar.",
    piiPreselectedBanner_other:
      "{{count}} dálkar voru forvaldir með sjálfvirkri greiningu á persónuupplýsingum. Haltu músinni yfir ? til að sjá hvers vegna, og taktu hakið úr þeim sem eru ekki í raun persónuupplýsingar.",
    pickerLabel: "Dálkar til að dulnefna",
    noneSelectedTitle: "Veldu a.m.k. einn dálk til að dulnefna",
    requestedBadgeTitle: "Upphaflega umbeðið",
    deidentifiedCaption: "{{selected}} af {{total}} dálkum verða dulnefndir",
    selfUploadNotice: "Þessi skrá verður aðeins sýnileg og niðurhalanleg af þér.",
    datasetExpiryLabel: "Gildistími gagnasafns",
    datasetExpiryHint:
      "Skildu eftir autt fyrir engan gildistíma. Ef gildistími er settur verður gagnasafninu eytt varanlega eftir þá dagsetningu.",
    descriptionLabel: "Lýsing (valfrjálst)",
    descriptionPlaceholder: "Hvað þetta gagnasafn inniheldur og allt sem vert er að vita um það",
    reviewAndConfirmButton: "Yfirfara og staðfesta",
    piiBlockedTitle: "Farðu yfir persónuupplýsingaábendingarnar og staðfestu áður en haldið er áfram",
  },
  confirm: {
    removedLabel: "Fjarlægt",
    pseudonymizedLabel: "Dulnefnt",
    explanationCaption:
      "Fjarlægðir dálkar eru teknir alveg úr skránni. Dulnefndir dálkar haldast í skránni en gildum þeirra er skipt út fyrir dulnefni — sjá forskoðun hér fyrir neðan.",
    explanationCaptionNoDrops:
      "Dulnefndir dálkar haldast í skránni en gildum þeirra er skipt út fyrir dulnefni — sjá forskoðun hér fyrir neðan.",
    previewHeading: "Forskoðun eftir að auðkenni eru fjarlægð",
    columnsRowsCaption:
      "{{columns}} dálkar · sýnir fyrstu {{shown}} af {{total}} röðum",
    visibleToOnlyYou: "Sýnilegt",
    onlyYou: "aðeins þér",
    visibleTo: "Sýnilegt",
    downloadableBy: "niðurhalanlegt af",
    metadataLabel: {
      projects: "þessu verkefni",
      org: "stofnuninni þinni",
      private: "engum (falið)",
    },
    downloadLabel: {
      none: "engum (beiðni nauðsynleg)",
      project: "öllum í verkefninu",
      selected_members: "völdum meðlimum",
    },
    uploadingButton: "Sendi inn…",
    uploadAndDeidentifyButton: "Hlaða upp og fjarlægja auðkenni",
  },
  errors: {
    fileTooLarge: "Skráin má ekki vera stærri en {{maxMB}} MB",
    readFailed: "Ekki tókst að lesa skrána",
    previewFailed: "Ekki tókst að útbúa forskoðun",
    uploadFailed: "Innsending mistókst",
  },
};

export default importWizard;
